import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import ManageAccountsRoundedIcon from "@mui/icons-material/ManageAccountsRounded";
import MoreVertRoundedIcon from "@mui/icons-material/MoreVertRounded";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { logout } from "../../../api/auth";
import { clearNotifications } from "../../../store/Notification";
import { resetSessionAuth } from "../../../store/Session";

interface OptionsMenuProps {
  onAction?: () => void;
}

export default function OptionsMenu({ onAction }: Readonly<OptionsMenuProps>) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleLogoutClick = () => {
    logout()
      .then(() => {
        dispatch(resetSessionAuth());
        dispatch(clearNotifications());
        navigate("/");
      })
      .catch((error) => {
        console.error(error);
        dispatch(resetSessionAuth());
        dispatch(clearNotifications());
        navigate("/");
      })
      .finally(() => onAction?.());
  };

  return (
    <>
      <IconButton
        size="small"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={{
          borderRadius: 2,
          "&:hover": { backgroundColor: (theme) => theme.palette.action.hover },
        }}
      >
        <MoreVertRoundedIcon fontSize="small" />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "bottom", horizontal: "right" }}
        slotProps={{
          paper: {
            sx: {
              borderRadius: 2,
              minWidth: 200,
              p: 0.5,
            },
          },
        }}
      >
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            navigate("/profile");
          }}
          sx={{
            borderRadius: 2,
            mx: 0.5,
            "&:hover": {
              backgroundColor: (theme: any) => theme.palette.action.hover,
            },
          }}
        >
          <ListItemIcon sx={{ minWidth: 32, "& svg": { fontSize: 20 } }}>
            <ManageAccountsRoundedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary={t("admin.users.my-profile")}
            slotProps={{ primary: { variant: "body2" } }}
          />
        </MenuItem>

        <Divider sx={{ my: 0.5 }} />

        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            handleLogoutClick();
          }}
          sx={{
            borderRadius: 2,
            mx: 0.5,
            "&:hover": {
              backgroundColor: (theme: any) => theme.palette.action.hover,
            },
          }}
        >
          <ListItemIcon sx={{ minWidth: 32, "& svg": { fontSize: 20 } }}>
            <LogoutRoundedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={t("generic.logout")} slotProps={{ primary: { variant: "body2" } }} />
        </MenuItem>
      </Menu>
    </>
  );
}